
























































import { computed, defineComponent, ref, watch } from '@vue/composition-api';
import { useUsers } from '@/bundles/Users/composables/useUsers';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { SubscriptionStatus } from '@/bundles/Users/types';
import { IQueryObjectParam, Nullable } from '@/bundles/App/type';
import { debounce } from '@/bundles/App/helpers';

import UsersListTable from '@/bundles/Users/components/UsersListTable.vue';
import AppRangeDatePicker from '@/bundles/App/components/AppRangeDatePicker.vue';

export default defineComponent({
  name: 'Users',

  components: {
    AppRangeDatePicker,
    UsersListTable,
  },

  setup: function () {
    const { fetch, users, total, pending, exportToCsv, downloadLoading } = useUsers();
    const { tableOptions, pageOffset } = usePagination({ sortBy: ['created'], sortDesc: [true] });
    const subscriptionFilter = ref<string[]>([]);
    const subscriptionStatusFilter = ref<Nullable<SubscriptionStatus>>(null);
    const dateRange = ref<string[]>([]);
    const subscriptionStatuses = Object.values(SubscriptionStatus);
    const keyword = ref('');
    const params = computed(() => {
      const queryParams: IQueryObjectParam[] = [
        {
          name: 'skip',
          value: pageOffset.value,
        },
        {
          name: 'take',
          value: tableOptions.value.itemsPerPage,
        },
      ];
      if (subscriptionFilter.value) {
        queryParams.push({
          name: 'subscription',
          value: subscriptionFilter.value,
        });
      }
      if (subscriptionStatusFilter.value) {
        queryParams.push({
          name: 'subscription_status',
          value: subscriptionStatusFilter.value,
        });
      }
      if (keyword.value) {
        queryParams.push({
          name: 'keyword',
          value: keyword.value,
        });
      }
      if (tableOptions.value.sortBy?.length) {
        queryParams.push({
          name: 'sort_by',
          value: tableOptions.value.sortBy[0]
        });
      }
      if (tableOptions.value.sortDesc?.length) {
        queryParams.push({
          name: 'sort_desc',
          value: true
        });
      }
      if (dateRange.value.length) {
        queryParams.push({
          name: 'date_range',
          value: dateRange.value
        });
      }
      return queryParams;
    });

    async function fetchWrapper() {
      const wrapper = document.querySelector('.base-table-wrapper .v-data-table__wrapper')
      if (wrapper) {
        wrapper.scrollTop = 0
      }
      await fetch(params.value);
    }
    function keywordSearch() {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
        return;
      }
      fetchWrapper();
    }
    const searchWrapper = debounce<typeof keywordSearch>(keywordSearch, 500);
    watch(keyword, () => {
      searchWrapper();
    });
    watch(() => tableOptions, () => fetchWrapper(), { deep: true, immediate: true });
    watch(() => [subscriptionFilter, subscriptionStatusFilter, dateRange], () => {
      if (tableOptions.value.page !== 1) {
        tableOptions.value.page = 1;
      } else {
        fetchWrapper();
      }
    }, { deep: true });
    function optionsChangeEventHandler(options: ITableOptions) {
      tableOptions.value = { ...options };
    }
    function downloadWrapper() {
      exportToCsv(params.value);
    }

    return {
      users,
      total,
      pending,
      tableOptions,
      subscriptionFilter,
      subscriptionStatusFilter,
      subscriptionStatuses,
      keyword,
      downloadLoading,
      dateRange,
      downloadWrapper,
      optionsChangeEventHandler,
    };
  },
});
